(function () {
	var button = document.querySelector('.report-description__read-more-button');
	var description = document.querySelector('.report-description__wrapper');

	if (button) {
		button.addEventListener('click', function () {
			description.classList.toggle('hide');
			button.classList.toggle('active');
		});
	}
})();
